import styled from "styled-components";
import successIcon from "../../assets/images/icons/ic_success.svg";
import warningIcon from "../../assets/images/icons/ic_warning.svg";
import caretDownIcon from "../../assets/images/icons/ic_caret_down.svg";
import infoBlueIcon from "../../assets/images/icons/ic_info_blue.svg";
import lockIcon from "../../assets/images/icons/ic_lock.svg";
import * as Variable from "../../CSSVariables";

export const CheckoutSummaryStyle = styled.div`
  > div {
    padding: 1.4rem 0;
    border-bottom: 1px solid ${Variable.alto};
  }
  .summary-title {
    font-size: 2rem;
    font-weight: ${Variable.semiBold};
    padding: 0;
    border: 0;

    @media only screen and (min-width: ${Variable.desktop}) {
      font-size: 2.2rem;
    }
  }
  .summary-amounts,
  .summary-preorder {
    .detail {
      display: flex;
      > div {
        flex: auto;
        padding: 6px 0;
      }
      .title {
      }
      .value {
        text-align: right;
      }
    }
  }
  .summary-chargenow-message {
    border: 0;
    color: ${Variable.boulder};
    font-size: 1.4rem;
    font-weight: ${Variable.regular};
  }

  .summary-total {
    .summary-total-title {
    }
    .total-detail {
      display: flex;
      > div {
        flex: auto;
        padding: 6px 0;
      }
      .total-title {
        font-size: 1.9rem;
        font-weight: ${Variable.medium};

        @media only screen and (min-width: ${Variable.desktop}) {
          // font-size: 2.2rem;
        }
      }
      .total-value {
        text-align: right;
        font-weight: ${Variable.medium};
        font-size: 1.9rem;

        @media only screen and (min-width: ${Variable.desktop}) {
          // font-size: 2.2rem;
        }

        &.vat {
          color: ${Variable.boulder};
          font-size: 1.4rem;
          font-weight: ${Variable.regular};
        }
      }
    }
  }
  .summary-promo {
    border: 0;
    .summary-section-title {
      margin: 6px 0 14px;
      display: block;
      font-size: 1.9rem;
      font-weight: ${Variable.semiBold};

      .promo-note {
        font-size: 1.2rem;
        font-weight: ${Variable.regular};
      }
    }
    .promo-form {
      position: relative;
      display: flex;

      input {
        background-color: ${Variable.white};
        border: 0;
        box-shadow: none;
        padding: 12px;

        &:focus::placeholder {
          color: transparent;
          font-size: 0;
        }

        &.with-value {
          ::placeholder {
            text-transform: uppercase;
            color: inherit;
          }
        }
        &.disabled {
          // pointer-events: none;
          // background-color: rgb(234 234 234);
          cursor: not-allowed;
        }
      }
      button {
        border: 0;
        background-color: transparent;
        cursor: pointer;
        margin-right: 12px;
        position: absolute;
        right: 0;
        top: 0;
        top: 50%;
        transform: translateY(-50%);

        &:hover {
          text-decoration: underline;
        }
        &.disabled {
          color: ${Variable.cloud};
          pointer-events: none;
        }
      }
    }
  }
  .summary-proceed {
    border: 0;

    button {
      margin: 0;
    }
    a {
      width: 100%;
      button {
        margin: 0;
      }
    }
  }
  .summary-terms {
    border: 0;
    font-size: 1.4rem;
    text-align: center;
    // padding: 1.2rem 2.4rem;
    padding: 1.2rem 0;
    // line-height: 22px;
    line-height: 1.4;

    @media only screen and (min-width: ${Variable.mobile}) {
      padding: 1.2rem 0;
    }
  }
  .summary-notes {
    font-size: 1.4rem;
    line-height: 1.4;
    text-align: center;
    padding: 1.2rem 0;

    .highlight {
      font-weight: ${Variable.semiBold};

      @media only screen and (min-width: ${Variable.mediumDesktop}) {
        display: block;
      }
    }
    border: 0;
  }
  .shopping-help {
    font-size: 1.4rem;
    line-height: 1.4;
    padding: 1.2rem 0;
    border: 0;
    text-align: center;

    a {
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .lockIcon {
    margin-right: 12px;
    vertical-align: middle;
    height: 20px;
    width: 20px;
  }
  .btn-txt {
    vertical-align: middle;

    &:before {
      content: "";
      background-image: url(${lockIcon});
      height: 20px;
      width: 20px;
      display: inline-block;
      background-repeat: no-repeat;
      background-size: contain;
      vertical-align: middle;
      margin-right: 0.6rem;
    }
  }
  .btn-disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  &.mobile-checkout-summary {
    background-color: ${Variable.mystic};
    position: relative;
    padding: 24px 15px;
    margin: 0 -15px;

    @media only screen and (min-width: ${Variable.mobile}) {
      display: none;
    }
    .summary-promo {
      position: relative;
      padding: 18px 0 0;

      .summary-section-title {
        margin: 0;
        display: block;
        // z-index: 2;
        position: relative;

        &:after {
          transition: all 0.1s ease;
          content: "";
          background-image: url(${caretDownIcon});
          height: 15px;
          width: 20px;
          position: absolute;
          right: 0;
          background-repeat: no-repeat;
          background-size: contain;
        }
      }

      .promo-form {
        margin: 22px 0 0;
        display: none;
      }
    }
    .summary-proceed,
    .summary-terms,
    .summary-notes,
    .shopping-help {
      display: none;
    }

    .toggle-promo-code {
      position: absolute;
      left: -9999px;
      width: 0;
      height: 0;
      opacity: 0;

      &:checked {
        ~ .summary-section-title {
          &:after {
            transform: rotate(180deg);
          }
        }

        ~ .promo-form {
          display: block;
        }
      }
    }
  }
  &.desktop-checkout-summary {
    .summary-title,
    .summary-amounts,
    .summary-total,
    .summary-preorder,
    .summary-promo,
    .summary-chargenow-message {
      display: none;

      @media only screen and (min-width: ${Variable.mobile}) {
        display: block;
      }
    }
  }
  a:hover {
    text-decoration: underline;
  }
`;

export const PromoMessageStyle = styled.div`
  margin-top: 12px;

  &.success {
    color: ${Variable.success};
    .promo-icon {
      background-image: url(${successIcon});
    }
  }
  &.error {
    color: ${Variable.milanoRed};
    .promo-icon {
      background-image: url(${warningIcon});
    }
  }
  .promo-icon {
    display: inline-block;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 20px;
    width: 20px;
    vertical-align: middle;
    margin-right: 4px;
  }
`;

export const CheckoutSummaryWarningNote = styled.div`
  font-size: 1.6rem;
  text-align: left;
  border: 1px solid ${Variable.congressBlue};
  color: ${Variable.congressBlue};
  padding: 2px 20px 2px 40px;
  position: relative;
  border-radius: 4px;
  margin-top: 12px;

  p {
    &:before {
      position: absolute;
      left: 14px;
      content: "";
      background-image: url(${infoBlueIcon});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      height: 18px;
      width: 18px;
      display: inline-block;
    }
  }
`;
